"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Base64 = require('js-base64').Base64;
exports.nonce = 'pers-token:1';
exports.surroundPlaceholders = function (placeholder, data) {
    return '{# ' + exports.nonce + ' ' + dataToBase64(data) + ' #}' + placeholder + '{# ' + exports.nonce + ' #}';
};
function base64ToJson(encoded) {
    return JSON.parse(Base64.fromBase64(encoded));
}
exports.base64ToJson = base64ToJson;
function dataToBase64(data) {
    return Base64.toBase64(JSON.stringify(data));
}
exports.dataToBase64 = dataToBase64;
function wrapTemplate(template) {
    return "<div>" + template + "</div>";
}
exports.wrapTemplate = wrapTemplate;
function unwrapTemplate(template) {
    return template.substring(5, template.length - 6);
}
exports.unwrapTemplate = unwrapTemplate;
function isV1Element(element) {
    return element.name === "span" &&
        element.attribs['e-personalization'];
}
exports.isV1Element = isV1Element;
function isV2Element(element) {
    return element.name === "span" &&
        element.attribs['e-token'] === "personalization" &&
        element.attribs['token-template'] === '%22%3C%25=%20template%20%25%3E%22';
}
exports.isV2Element = isV2Element;
function isStringElement(element) {
    return element.type === "text";
}
exports.isStringElement = isStringElement;
//# sourceMappingURL=utils.js.map